import {
  Building2,
  Landmark,
  GitBranch,
  Circle,
  Layers,
  Globe2,
} from "lucide-react";

const LEVEL_REGEX = /^level_(\d+)$/;

const LEVEL_STYLES = [
  { color: "text-sky-600", icon: Building2 },
  { color: "text-emerald-600", icon: Landmark },
  { color: "text-amber-600", icon: GitBranch },
  { color: "text-indigo-600", icon: Circle },
];

export const ORGANIZATION_TYPE_META = {
  parent_company: {
    label: "Parent Company",
    color: "text-indigo-600",
    icon: Building2,
  },
  business_type: {
    label: "Business Type",
    color: "text-teal-600",
    icon: Layers,
  },
  country: {
    label: "Country",
    color: "text-emerald-600",
    icon: Globe2,
  },
};

const getLevelMeta = (level) => {
  const style =
    LEVEL_STYLES[(level - 1) % LEVEL_STYLES.length] || LEVEL_STYLES[0];
  return {
    label: `Level ${level}`,
    color: style.color,
    icon: style.icon,
  };
};

export const getUnitTypeMeta = (type) =>
  ORGANIZATION_TYPE_META[type] ||
  (() => {
    const match = LEVEL_REGEX.exec(type || "");
    if (match) {
      return getLevelMeta(Number(match[1]));
    }
    return {
      label: type,
      color: "text-slate-500",
      icon: Circle,
    };
  })();
